import { CSSProperties } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { TFunction } from 'i18next';
import { withTranslation } from 'react-i18next';

const ConnectionError = ({ t, overlay }: { t: TFunction; overlay?: boolean; }) => {
  const sx: CSSProperties = {}

  if (overlay) {
    sx.backgroundColor = "rgba(255,255,255, 0.5)";
    sx.position = "absolute";
    sx.top = 0;
    sx.left = 0;
  }

  return (
    <div style={sx} className="connection-error">
      <ErrorOutlineIcon />
      <p>{t('connection-error')}</p>
    </div>);
}

export default withTranslation()(ConnectionError);